// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"9ef99431","54":"81437318","65":"59335b71","98":"18751ed4","253":"7de58090","301":"48402062","358":"be397315","431":"3709eda4","470":"027a9ae3","489":"67cd1487","672":"822f2da6","683":"6343dd12","689":"ce84b19b","864":"64c559af"}[chunkId] + ".chunk.js";
};